/** @format */

import React from 'react';
import { Grid } from '@mui/material';
import { useStyles } from './Style';
import { useFormContext } from 'react-hook-form';
import { numberWithCommas } from 'utility';
import { Icons, PriceLabel } from 'components';
import {
  SUBSCRIPTION_TYPES,
  SETTLEMENT_PERIOD_TYPE,
  PERIOD_TYPES,
} from '../../../constants/SubscriptionConstants';

const Overview = ({ products, guilds, businesses, consumeType, targetUser , currencyText}) => {
  const classes = useStyles();
  const { watch } = useFormContext();

  const isEmpty = (v) => {
    if (v == null || v === undefined) return true;
    if (v?.length <= 0) return true;
    return false;
  };

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      spacing={0}
      style={{ padding: 0 }}
      item
      xs={12}
      className={classes.root}
    >
      <Grid xs={12} container>
        <Grid item xs={4}>
          <b>عنوان</b>
        </Grid>
        <Grid item xs={8}>
          {isEmpty(watch('name')) ? '-' : watch('name')}
        </Grid>
      </Grid>
      <Grid xs={12} container>
        <Grid item xs={4}>
          <b>نوع طرح</b>
        </Grid>
        <Grid item xs={8}>
          {isEmpty(watch('type'))
            ? '-'
            : SUBSCRIPTION_TYPES.find((v) => v?.value === watch('type'))?.label ?? '-'}
        </Grid>
      </Grid>
      {watch('type') !== 'SUBSCRIPTION_PLAN_TYPE_POST_PAID' ? (
        <Grid xs={12} container>
          <Grid item xs={4}>
            <b>قیمت</b>
          </Grid>
          <Grid item xs={8}>
            {isEmpty(watch('price')) ? '-' : <PriceLabel amount={watch('price')} currency={currencyText} />}
          </Grid>
        </Grid>
      ) : (
        <>
          <Grid xs={12} container>
            <Grid item xs={4}>
              <b>سقف بدهکاری طرح</b>
            </Grid>
            <Grid item xs={8}>
              {isEmpty(watch('maxDebtorAmount'))
                ? '-'
                : <PriceLabel amount={watch('maxDebtorAmount')} currency={currencyText} />}
            </Grid>
          </Grid>
          <Grid xs={12} container>
            <Grid item xs={4}>
              <b>دوره تسویه طرح</b>
            </Grid>
            <Grid item xs={8}>
              {isEmpty(watch('settlementPeriodTypeCode'))
                ? '-'
                : SETTLEMENT_PERIOD_TYPE.find((v) => v?.value === watch('settlementPeriodTypeCode'))
                  ?.label ?? '-'}
            </Grid>
          </Grid>
        </>
      )}
      <Grid xs={12} container>
        <Grid item xs={4}>
          <b>بازه زمانی</b>
        </Grid>
        <Grid item xs={8}>
          {isEmpty(watch('periodTypeCount')) || isEmpty(watch('periodTypeCode'))
            ? '-'
            : `${watch('periodTypeCount')} ${PERIOD_TYPES.find((v) => v?.value === watch('periodTypeCode'))?.shortLabel ?? '-'
            }`}
        </Grid>
      </Grid>
      <Grid xs={12} container>
        <Grid item xs={4}>
          <b>محدودیت دفعات استفاده</b>
        </Grid>
        <Grid item xs={8}>
          {isEmpty(watch('usageCountLimit'))
            ? '-'
            : `${numberWithCommas(watch('usageCountLimit'))} مرتبه`}
        </Grid>
      </Grid>
      <Grid xs={12} container>
        <Grid item xs={4}>
          <b>محدودیت مبلغ قابل استفاده</b>
        </Grid>
        <Grid item xs={8}>
          {isEmpty(watch('usageAmountLimit'))
            ? '-'
            : <PriceLabel amount={watch('usageAmountLimit')} currency={currencyText} />}
        </Grid>
      </Grid>
      <Grid xs={12} container>
        <Grid item xs={4}>
          <b>حساب محل واریز درآمد</b>
        </Grid>
        <Grid item xs={8}>
          {isEmpty(watch('guildCode')) ? '-' : watch('guildCode')?.name ?? '-'}
        </Grid>
      </Grid>
      <Grid xs={12} container>
        <Grid item xs={4}>
          <b>مالیات</b>
        </Grid>
        <Grid item xs={8}>
          {isEmpty(watch('taxRate')) ? '-' : `${watch('taxRate')} درصد`}
        </Grid>
      </Grid>

      <Grid item xs={12} style={{ paddingTop: 16 }}>
        <b>محدودیت‌های استفاده:</b>
      </Grid>

      <Grid item xs={12}>
        <li className={classes.listHeadLine}>
          <span>
            <Icons icon="productList" color="#667585" size={20} />
          </span>
          {products && products?.length > 0 ? 'محصولات:' : 'همه محصولات'}
        </li>

        {products && products?.length > 0 ? (
          <>
            {products.map((v, k) => (
              <li className={classes.usageItem}>
                {v?.entityId ?? v?.id ?? ''}. {v?.name}
              </li>
            ))}
          </>
        ) : null}
      </Grid>

      <Grid item xs={12}>
        <li className={classes.listHeadLine}>
          <span>
            <Icons icon="Organ" color="#667585" size={20} />
          </span>
          {guilds && guilds?.length > 0
            ? 'حساب‌های تفصیلی کسب‌وکار:'
            : 'همه حساب‌های تفصیلی کسب‌وکار'}
        </li>

        {guilds && guilds?.length > 0 ? (
          <>
            {guilds.map((v, k) => (
              <li className={classes.usageItem}>
                {v?.id}. {v?.name}
              </li>
            ))}
          </>
        ) : null}
      </Grid>

      <Grid item xs={12}>
        <li className={classes.listHeadLine}>
          <span>
            <Icons icon="Organizationals" color="#667585" size={20} />
          </span>
          {businesses && businesses?.length > 0 ? 'کسب‌وکارها:' : 'همه کسب‌وکارها'}
        </li>

        {businesses && businesses?.length > 0 ? (
          <>
            {businesses.map((v, k) => (
              <li className={classes.usageItem}>
                {v?.id}. {v?.name}
              </li>
            ))}
          </>
        ) : null}
      </Grid>
      {

      }
    </Grid>
  );
};



export default Overview;
